module.exports = __webpack_public_path__ + "static/media/instagram.e82d4922.svg";